import { Component, OnInit } from '@angular/core';
import { MdDialog } from '@angular/material';
import { Observable } from 'rxjs/observable';

import { Member } from '../../models/member';
import { MemberService } from '../../services/member.service';
import { AddMemberComponent } from '../add-member/add-member.component';
import { UpdateMemberComponent } from '../update-member/update-member.component';

@Component({
  selector: 'app-members',
  templateUrl: './members.component.html',
  styleUrls: ['./members.component.scss']
})
export class MembersComponent implements OnInit {
	public members: Observable<Member[]>;

  constructor(private dialog: MdDialog,
							private memberService: MemberService) {
		this.members = memberService.getMembers();
	}

  ngOnInit() {
	}

	public add(): void {
		let dialogRef = this.dialog.open(AddMemberComponent, {
			width: '300px'
		});
	}

	public update(member: Member): void {
		let dialogRef = this.dialog.open(UpdateMemberComponent, {
			width: '300px'
		});

		dialogRef.componentInstance.updateForm(member);
	}

}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/components/members/members.component.ts